// GENERATED by scripts/gen-look.py from vendor-ref/nanome@868d90f: Assets/Scripts/src/Nanome.Adapter/Display/ElementColors.cs (ElementColors.Cpk)
// Do not edit by hand.

/** Jmol CPK colors by atomic number; fallback is ELEMENT_COLOR_DEFAULT. */
export const ELEMENT_COLOR_DEFAULT = 0xFF00FF;
export const ELEMENT_COLORS: ReadonlyMap<number, number> = new Map([
  [1, 0xFFFFFF], // H Hydrogen
  [2, 0xD9FFFF], // He Helium
  [3, 0xCC80FF], // Li Lithium
  [4, 0xC2FF00], // Be Beryllium
  [5, 0xFFB5B5], // B Boron
  [6, 0x909090], // C Carbon
  [7, 0x3050F8], // N Nitrogen
  [8, 0xFF0D0D], // O Oxygen
  [9, 0x90E050], // F Fluorine
  [10, 0xB3E3F5], // Ne Neon
  [11, 0xAB5CF2], // Na Sodium
  [12, 0x8AFF00], // Mg Magnesium
  [13, 0xBFA6A6], // Al Aluminium
  [14, 0xF0C8A0], // Si Silicon
  [15, 0xFF8000], // P Phosphorus
  [16, 0xFFFF30], // S Sulfur
  [17, 0x1FF01F], // Cl Chlorine
  [18, 0x80D1E3], // Ar Argon
  [19, 0x8F40D4], // K Potassium
  [20, 0x3DFF00], // Ca Calcium
  [21, 0xE6E6E6], // Sc Scandium
  [22, 0xBFC2C7], // Ti Titanium
  [23, 0xA6A6AB], // V Vanadium
  [24, 0x8A99C7], // Cr Chromium
  [25, 0x9C7AC7], // Mn Manganese
  [26, 0xE06633], // Fe Iron
  [27, 0xF090A0], // Co Cobalt
  [28, 0x50D050], // Ni Nickel
  [29, 0xC88033], // Cu Copper
  [30, 0x7D80B0], // Zn Zinc
  [31, 0xC28F8F], // Ga Gallium
  [32, 0x668F8F], // Ge Germanium
  [33, 0xBD80E3], // As Arsenic
  [34, 0xFFA100], // Se Selenium
  [35, 0xA62929], // Br Bromine
  [36, 0x5CB8D1], // Kr Krypton
  [37, 0x702EB0], // Rb Rubidium
  [38, 0x00FF00], // Sr Strontium
  [39, 0x94FFFF], // Y Yttrium
  [40, 0x94E0E0], // Zr Zirconium
  [41, 0x73C2C9], // Nb Niobium
  [42, 0x54B5B5], // Mo Molybdenum
  [43, 0x3B9E9E], // Tc Technetium
  [44, 0x248F8F], // Ru Ruthenium
  [45, 0x0A7D8C], // Rh Rhodium
  [46, 0x006985], // Pd Palladium
  [47, 0xC0C0C0], // Ag Silver
  [48, 0xFFD98F], // Cd Cadmium
  [49, 0xA67573], // In Indium
  [50, 0x668080], // Sn Tin
  [51, 0x9E63B5], // Sb Antimony
  [52, 0xD47A00], // Te Tellurium
  [53, 0x940094], // I Iodine
  [54, 0x429EB0], // Xe Xenon
  [55, 0x57178F], // Cs Caesium
  [56, 0x00C900], // Ba Barium
  [57, 0x70D4FF], // La Lanthanum
  [58, 0xFFFFC7], // Ce Cerium
  [59, 0xD9FFC7], // Pr Praseodymium
  [60, 0xC7FFC7], // Nd Neodymium
  [61, 0xA3FFC7], // Pm Promethium
  [62, 0x8FFFC7], // Sm Samarium
  [63, 0x61FFC7], // Eu Europium
  [64, 0x45FFC7], // Gd Gadolinium
  [65, 0x30FFC7], // Tb Terbium
  [66, 0x1FFFC7], // Dy Dysprosium
  [67, 0x00FF9C], // Ho Holmium
  [68, 0x00E675], // Er Erbium
  [69, 0x00D452], // Tm Thulium
  [70, 0x00BF38], // Yb Ytterbium
  [71, 0x00AB24], // Lu Lutetium
  [72, 0x4DC2FF], // Hf Hafnium
  [73, 0x4DA6FF], // Ta Tantalum
  [74, 0x2194D6], // W Tungsten
  [75, 0x267DAB], // Re Rhenium
  [76, 0x266696], // Os Osmium
  [77, 0x175487], // Ir Iridium
  [78, 0xD0D0E0], // Pt Platinum
  [79, 0xFFD123], // Au Gold
  [80, 0xB8B8D0], // Hg Mercury
  [81, 0xA6544D], // Tl Thallium
  [82, 0x575961], // Pb Lead
  [83, 0x9E4FB5], // Bi Bismuth
  [84, 0xAB5C00], // Po Polonium
  [85, 0x754F45], // At Astatine
  [86, 0x428296], // Rn Radon
  [87, 0x420066], // Fr Francium
  [88, 0x007D00], // Ra Radium
  [89, 0x70ABFA], // Ac Actinium
  [90, 0x00BAFF], // Th Thorium
  [91, 0x00A1FF], // Pa Protactinium
  [92, 0x008FFF], // U Uranium
  [93, 0x0080FF], // Np Neptunium
  [94, 0x006BFF], // Pu Plutonium
  [95, 0x545CF2], // Am Americium
  [96, 0x785CE3], // Cm Curium
  [97, 0x8A4FE3], // Bk Berkelium
  [98, 0xA136D4], // Cf Californium
  [99, 0xB31FD4], // Es Einsteinium
  [100, 0xB31FBA], // Fm Fermium
  [101, 0xB30DA6], // Md Mendelevium
  [102, 0xBD0D87], // No Nobelium
  [103, 0xC70066], // Lr Lawrencium
  [104, 0xCC0059], // Rf Rutherfordium
  [105, 0xD1004F], // Db Dubnium
  [106, 0xD90045], // Sg Seaborgium
  [107, 0xE00038], // Bh Bohrium
  [108, 0xE6002E], // Hs Hassium
  [109, 0xEB0026], // Mt Meitnerium
]);
